import React from 'react';
import ActivityCard from './ActivityCard';
import './ActivityList.css';

export default function ActivityList({ activities, view, onToggle, onEdit, onToggleActive, currentUser }) {
  if (activities.length === 0) {
    return (
      <div className="empty-state fade-in">
        <span className="empty-icon">✦</span>
        <p className="empty-title">No activities found</p>
        <p className="empty-sub">Try adjusting your filters or add a new activity.</p>
      </div>
    );
  }

  if (view === 'board') {
    const pending = activities.filter(a => a.status === 'pending');
    const completed = activities.filter(a => a.status === 'completed');
    return (
      <div className="board-view fade-in">
        <div className="board-col">
          <div className="board-col-header board-pending">
            <span>Pending</span>
            <span className="board-count">{pending.length}</span>
          </div>
          {pending.map((a, i) => (
            <ActivityCard key={a.id} activity={a} onToggle={onToggle} onEdit={onEdit} onToggleActive={onToggleActive} currentUser={currentUser} style={{ animationDelay: `${i * 40}ms` }} />
          ))}
        </div>
        <div className="board-col">
          <div className="board-col-header board-completed">
            <span>Completed</span>
            <span className="board-count">{completed.length}</span>
          </div>
          {completed.map((a, i) => (
            <ActivityCard key={a.id} activity={a} onToggle={onToggle} onEdit={onEdit} onToggleActive={onToggleActive} currentUser={currentUser} style={{ animationDelay: `${i * 40}ms` }} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="list-view fade-in">
      {activities.map((a, i) => (
        <ActivityCard key={a.id} activity={a} onToggle={onToggle} onEdit={onEdit} onToggleActive={onToggleActive} currentUser={currentUser} style={{ animationDelay: `${i * 30}ms` }} />
      ))}
    </div>
  );
}
